// src/ui/VibeAvatar.jsx — the circle beside a name in Vibes.
//
// 🟥 IT LIVES IN ITS OWN FILE BECAUSE TWO PLACES NEED IT. It began inside
//    VibesScreen.jsx, and the followers pane importing it from there would have
//    made a cycle — VibesScreen imports the pane, the pane imports VibesScreen.
//    Bundlers usually survive that on a hoisted function declaration and
//    sometimes do not, and the failure is a blank pane at runtime rather than a
//    build error. Ten lines in a file of their own is cheaper than finding out.
//
// 🟢 ONE AVATAR, so the two surfaces differ in nothing — including the case
//    that actually matters, which is a picture that fails to load: two retries
//    under different cache keys, then the initial.
import React, { useEffect, useState } from 'react';

export default function Pic({ src, name, size = 38 }) {
  const [failed, setFailed] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => { setFailed(false); setAttempt(0); }, [src]);

  const usable = typeof src === 'string' && src && /^(https?:|data:|blob:)/i.test(src) && !failed;
  if (!usable) {
    return (
      <span className="vb-avatar vb-ph" style={{ width: size, height: size, fontSize: size * 0.4 }}>
        {(name || '?').trim().charAt(0).toUpperCase()}
      </span>
    );
  }
  return (
    <img
      key={`${src}#${attempt}`}
      className="vb-avatar" style={{ width: size, height: size }} src={src} alt=""
      onError={() => { if (attempt < 2) setAttempt((a) => a + 1); else setFailed(true); }}
    />
  );
}
